var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 20,
    viewBox: "0 0 25 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.571 4.044c0-1.072.47-2.101 1.308-2.86C5.716.427 6.852 0 8.036 0h8.928c1.184 0 2.32.426 3.157 1.185.837.758 1.308 1.787 1.308 2.86v2.507c1.008.186 1.914.683 2.565 1.405A3.817 3.817 0 0125 10.515v8.089c0 .214-.094.42-.262.572a.942.942 0 01-.63.236.942.942 0 01-.632-.236.772.772 0 01-.262-.572v-4.045H1.786v4.045c0 .214-.094.42-.262.572a.942.942 0 01-.631.236.942.942 0 01-.631-.236.772.772 0 01-.262-.572v-8.089c0-.932.355-1.836 1.006-2.558.65-.722 1.557-1.219 2.565-1.405V4.044zm-1.785 8.898h21.428v-2.427c0-.644-.282-1.26-.784-1.716a2.826 2.826 0 00-1.894-.71H4.464c-.71 0-1.391.255-1.894.71a2.317 2.317 0 00-.784 1.716v2.427zm17.857-8.898c0-.643-.282-1.26-.785-1.716a2.826 2.826 0 00-1.894-.71H8.036c-.71 0-1.392.255-1.894.71a2.317 2.317 0 00-.785 1.716v2.427h1.786v-.809c0-.215.094-.42.261-.572a.942.942 0 01.632-.237h2.678c.237 0 .464.085.632.237a.772.772 0 01.261.572v.809h1.786v-.809c0-.215.094-.42.261-.572a.942.942 0 01.632-.237h2.678c.237 0 .464.085.632.237a.772.772 0 01.261.572v.809h1.786V4.044z",
    fill: "#828282"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBed);
export default __webpack_public_path__ + "static/media/bed.d19e92e3.svg";
export { ForwardRef as ReactComponent };